import {createSlice, SerializedError} from "@reduxjs/toolkit";
import {UserRole} from "./types";
import {getUserRoleThunk} from "./auth.thunk";
import {RootState} from "../../redux/store";

interface AuthState {
    role: UserRole | null;
    error: SerializedError | null;
}

const initialState: AuthState = {
    role: null,
    error: null
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: builder =>
        builder
            .addCase(getUserRoleThunk.fulfilled, (state, action) => {
                state.role = action.payload.role
            })
            .addCase(getUserRoleThunk.rejected, (state, action) => {
                state.error = action.error;
            })
});

export const selectUserRole = (state: RootState) => state.auth.role;

export default authSlice.reducer;